import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { formatDate } from "@angular/common";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import * as fS from "file-saver";

import { Status } from "@helper/abstraction/status";

export type PopupMode = "LIST" | "ITEM";

export const SelectTypeValues: { id: PopupMode; name: string }[] = [
    { id: "ITEM", name: $localize`По товарной позиции` },
    { id: "LIST", name: $localize`Все коды` },
];

@Component({
    selector: "app-export-codes-popup",
    templateUrl: "./export-codes-popup.component.html",
    styleUrls: ["./export-codes-popup.component.scss"]
})
export class ExportCodesPopupComponent implements OnInit {
    public form?: FormGroup;
    public gtin?: string;
    public itemCodeList?: string[];
    public itemsCodeList?: string[];
    public selectTypeValues = SelectTypeValues;
    public disableSelect = false;
    public mode: PopupMode = "ITEM";

    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef,
        private fb: FormBuilder,
    ) { }

    public transformFn(status: Status): string {
        return status.name;
    }

    public ngOnInit(): void {
        this.setData();
        this.initForm();
    }

    public close(): void {
        this.ref.close();
    }

    public export(): void {
        const fV = this.form?.getRawValue();
        const newDate = formatDate(new Date(), `dd.MM.yyyy HH-mm`, "ru-BY");
        const data = (fV.selectType.id === "LIST" ? this.itemsCodeList : this.itemCodeList)?.map(el => {
            return fV.isBase64 ? btoa(el) : el;
        }).join("\r\n");
        const fileName = `${fV.selectType.id === "LIST" ? $localize`Коды идентификации` : this.gtin}_${newDate}.txt`;

        fS(new Blob([data!], { type: "text/plain;charset=utf-8" }), fileName);
    }

    private initForm(): void {
        const currentSelectTtype = this.selectTypeValues.filter(el => el.id === this.mode)[0];
        this.form = this.fb.group({
        selectType: [currentSelectTtype],
        isBase64: [false],
        });
    }

    private setData(): void {
        this.config.width = "500px";
        this.config.header = $localize`Экспорт кодов`;
        for (let k in this.config.data) {
        (this as any)[k] = this.config.data[k];
        }
    }
}
